import { createReduxStore } from '#packages/apilib';
import type { HiddenElement } from './hiddenElementsTypes.ts';

interface State {
  masterPageHiddenElements: HiddenElement[];
  focusedPageHiddenElements: HiddenElement[];
  interactionsHiddenElements: HiddenElement[];
}

const getInitialState = (): State => ({
  masterPageHiddenElements: [],
  focusedPageHiddenElements: [],
  interactionsHiddenElements: [],
});

export const HiddenElementsStore = createReduxStore({
  getInitialState,
  selectors: {
    getHiddenElementsTotalCount: (state) =>
      state.masterPageHiddenElements.length +
      state.focusedPageHiddenElements.length +
      state.interactionsHiddenElements.length,
    getMasterPageHiddenElements: (state) => state.masterPageHiddenElements,
    getFocusedPageHiddenElements: (state) => state.focusedPageHiddenElements,
    getInteractionsHiddenElements: (state) => state.interactionsHiddenElements,
  },
  actions: {
    optimisticallyRemoveHiddenElement: (state, compId: string) => ({
      ...state,
      masterPageHiddenElements: state.masterPageHiddenElements.filter(
        (element) => element.compId !== compId,
      ),
      focusedPageHiddenElements: state.focusedPageHiddenElements.filter(
        (element) => element.compId !== compId,
      ),
      interactionsHiddenElements: state.interactionsHiddenElements.filter(
        (element) => element.compId !== compId,
      ),
    }),
    setMasterPageHiddenElements: (
      state,
      masterPageHiddenElements: HiddenElement[],
    ) => ({
      ...state,
      masterPageHiddenElements,
    }),
    setFocusedPageHiddenElements: (
      state,
      focusedPageHiddenElements: HiddenElement[],
    ) => ({
      ...state,
      focusedPageHiddenElements,
    }),
    setInteractionsHiddenElements: (
      state,
      interactionsHiddenElements: HiddenElement[],
    ) => ({
      ...state,
      interactionsHiddenElements,
    }),
  },
});
